// // ============================================================
// // src/components/Ticker.js
// // ============================================================
// import React from "react";
// import { useHospital } from "../context/HospitalContext";

// export default function Ticker() {
//   const { hospital } = useHospital();

//   // ✅ Use hospital tickerItems if set, else fallback defaults
//   const items =
//     hospital.tickerItems && hospital.tickerItems.length > 0
//       ? hospital.tickerItems
//       : [
//           "Painless Procedures",
//           "Cosmetic Dentistry",
//           "Award-Winning Care",
//           "Same-Day Appointments",
//           "All Insurance Accepted",
//           "20+ Years Experience",
//           "Advanced Anesthesia",
//           "State-of-the-Art Facility",
//         ];

//   const doubled = [...items, ...items];

//   return (
//     <div className="ticker">
//       <div className="ticker-inner">
//         {doubled.map((item, i) => (
//           <React.Fragment key={i}>
//             <span className="ticker-item">{item}</span>
//             <span className="ticker-sep">·</span>
//           </React.Fragment>
//         ))}
//       </div>
//     </div>
//   );
// }

// ============================================================
// src/components/Ticker.js
// ✅ Ticker items by hospital type — overrides dental defaults
// ============================================================
import React from "react";
import { useHospital } from "../context/HospitalContext";

const DENTAL_DEFAULT_TICKER = [
  "Painless Procedures",
  "Cosmetic Dentistry",
  "Award-Winning Care",
  "Same-Day Appointments",
  "All Insurance Accepted",
  "20+ Years Experience",
  "Advanced Anesthesia",
  "State-of-the-Art Facility",
];

const DEFAULT_TICKER_BY_TYPE = {
  dental: [
    "Painless Procedures",
    "Cosmetic Dentistry",
    "Award-Winning Care",
    "Same-Day Appointments",
    "All Insurance Accepted",
    "20+ Years Experience",
    "Advanced Anesthesia",
    "State-of-the-Art Facility",
  ],
  ayurved: [
    "100% Natural Treatments",
    "Herbal Skin & Beauty Care",
    "Nationally Recognized Wellness Center",
    "Flexible Consultation Slots",
    "Affordable Wellness Packages",
    "20+ Years of Ayurvedic Practice",
    "Dosha-Based Personalized Therapy",
    "Authentic Panchakarma Center",
  ],
  ortho: [
    "Minimally Invasive Surgeries",
    "Sports Injury Rehabilitation",
    "Award-Winning Surgical Team",
    "Same-Day OPD Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years Surgical Excellence",
    "Advanced Pain Management",
    "Fully Equipped Surgical OT",
  ],
  eye: [
    "Bladeless & Painless Surgeries",
    "Oculoplasty & Cosmetic Eye Care",
    "Award-Winning Eye Care Center",
    "Same-Day Eye Checkups",
    "All Insurance & Cashless Accepted",
    "20+ Years in Ophthalmology",
    "Topical Anesthesia Technology",
    "Advanced Laser & Imaging Center",
  ],
  cardiology: [
    "Minimally Invasive Cardiac Procedures",
    "Preventive Heart Care Programs",
    "Award-Winning Cardiac Center",
    "Emergency & Same-Day Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years of Cardiac Excellence",
    "Advanced Cardiac Anesthesia",
    "Cath Lab & Advanced Cardiac ICU",
  ],
  pediatric: [
    "Gentle & Child-Friendly Procedures",
    "Child Growth & Nutrition Counseling",
    "Award-Winning Children's Hospital",
    "Same-Day Pediatric Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years Caring for Children",
    "Safe Pediatric Anesthesia",
    "Child-Safe & Friendly Environment",
  ],
  general: [
    "Minimally Invasive Procedures",
    "Multi-Specialty Departments",
    "NABH Accredited Hospital",
    "Same-Day OPD & Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years of Medical Excellence",
    "Advanced ICU & Critical Care",
    "Fully Equipped Multi-Specialty Facility",
  ],
};

export default function Ticker() {
  const { hospital } = useHospital();
  const type = (hospital.type || "dental").toLowerCase();

  const saved = hospital.tickerItems || [];

  // ✅ Use type-specific default if:
  // 1. Nothing saved yet, OR
  // 2. Non-dental hospital still has dental defaults in DB
  const isDentalDefault =
    saved.length > 0 &&
    DENTAL_DEFAULT_TICKER.every((item) => saved.includes(item));

  const items =
    saved.length === 0 || (type !== "dental" && isDentalDefault)
      ? DEFAULT_TICKER_BY_TYPE[type] || DEFAULT_TICKER_BY_TYPE.dental
      : saved;

  const doubled = [...items, ...items];

  return (
    <div className="ticker">
      <div className="ticker-inner">
        {doubled.map((item, i) => (
          <React.Fragment key={i}>
            <span className="ticker-item">{item}</span>
            <span className="ticker-sep">·</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
